/**
 * Responsive Tables Enhancement
 * Automaticky obalí tabulky do scrollovacího kontejneru pro mobilní zařízení
 */

document.addEventListener('DOMContentLoaded', function() {
  // Kontrola jestli jsme na stránce s články (dodatečná optimalizace)
  const articleContent = document.querySelector('.article-content, .main-article, [data-section-type="article"]');
  if (!articleContent) return;
  
  // Najdeme všechny tabulky v prose obsahu
  const tables = document.querySelectorAll('.prose table');
  
  if (tables.length === 0) return;
  
  // Throttling funkce pro resize
  function throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  }
  
  tables.forEach(function(table) {
    // Zkontrolujeme, jestli už není tabulka obalená
    if (table.parentElement.classList.contains('table-wrapper')) {
      return;
    }
    
    // Vytvoříme wrapper kontejner
    const wrapper = document.createElement('div');
    wrapper.className = 'table-wrapper';
    
    // Vložíme wrapper před tabulku
    table.parentNode.insertBefore(wrapper, table);
    
    // Přesuneme tabulku do wrapperu
    wrapper.appendChild(table);
    
    // Přidáme indikátory pro scroll pokud je potřeba
    addScrollIndicators(wrapper);
  });
  
  function addScrollIndicators(wrapper) {
    const table = wrapper.querySelector('table');
    if (!table) return;
    
    // Funkce pro aktualizaci indikátorů
    function updateIndicators() {
      const hasOverflow = wrapper.scrollWidth > wrapper.clientWidth;
      wrapper.setAttribute('data-scrollable', hasOverflow);
      
      if (hasOverflow) {
        // Přidáme shadow indikátory
        if (!wrapper.querySelector('.scroll-shadow-left')) {
          const leftShadow = document.createElement('div');
          leftShadow.className = 'scroll-shadow scroll-shadow-left';
          wrapper.appendChild(leftShadow);
          
          const rightShadow = document.createElement('div');
          rightShadow.className = 'scroll-shadow scroll-shadow-right';
          wrapper.appendChild(rightShadow);
        }
        
        // Aktualizujeme shadow podle pozice scrollu
        updateShadows();
      }
    }
    
    function updateShadows() {
      const leftShadow = wrapper.querySelector('.scroll-shadow-left');
      const rightShadow = wrapper.querySelector('.scroll-shadow-right');
      
      if (!leftShadow || !rightShadow) return;
      
      const scrollLeft = wrapper.scrollLeft;
      const maxScrollLeft = wrapper.scrollWidth - wrapper.clientWidth;
      
      // Levý shadow
      leftShadow.style.opacity = scrollLeft > 0 ? '1' : '0';
      
      // Pravý shadow
      rightShadow.style.opacity = scrollLeft < maxScrollLeft ? '1' : '0';
    }
    
    // Posloucháme události s throttling
    wrapper.addEventListener('scroll', updateShadows);
    window.addEventListener('resize', throttle(updateIndicators, 250));
    
    // Inicializujeme indikátory
    updateIndicators();
  }
});

// Add CSS for scroll indicators (pouze pokud je potřeba)
if (document.querySelector('.prose table')) {
  const style = document.createElement('style');
  style.textContent = `
    .table-scroll-indicator {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(0, 0, 0, 0.7);
      color: white;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      pointer-events: none;
      transition: opacity 0.3s ease;
      z-index: 10;
    }
    
    .table-scroll-indicator--left {
      left: 10px;
    }
    
    .table-scroll-indicator--right {
      right: 10px;
    }
    
    @media screen and (min-width: 1000px) {
      .table-scroll-indicator {
        display: none;
      }
    }
  `;

  document.head.appendChild(style);
} 